import config from "../../src/common/default_config";

export default class options extends config {
  // Kiosk settings

  // pdf options
  static page_ratio = 1.4745;
  static page_width_reference = 100000;
  static page_height_reference = 100000;

  static page_ratio = 1.4745;
  static page_width_reference = 100000;
  static page_height_reference = 100000;
  static usePdfDesktop = true;
  static usePdfPhoneNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfPhone = true;
  static usePdfTabletNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfTablet = true;
  static logoRedirect = "https://www.dhnet.be";

  static replicaReadingModeToggle = {
    phone: false,
    tablet: true,
    desktop: true,
  };

  // social sharing
  static sharingOptions = {
    Facebook: true,
    WhatsApp: true,
    TwitterX: true,
    Mail: true,
    MailSubject: null,
    MailSubjectIntro: "Article shared - ",
  };
  static socialSharingHash = "social";
  static shareFromReader = true;
  static useSliderForPromospot = true;
  static useSliderForHorsSeries = true;
  static useSliderForArchive = true;
  static singlePageView = true;
  static printCroppedPdf = true;

  // SSO
  static SSOEnabled = true;
  static getSSOTokenFromUrl = false;
  static paywallRedirectionUrl = true;
  static externalPaywallMaxRedirectionNumber = 1000;
  static urlRedirectParameter = "redirect";
  static SSOCookieName = "__utp";
  static deleteSSOCookie = false;
  static SSOCookieOptions = {
    path: "",
    domain: ".dhnet.be",
  };

  static pdfDownloadButtonsConfig = {
    ...config.pdfDownloadButtonsConfig,
    touchDownloadPdf: true,
  };

  // Edition analytics
  static product_name_for_engage_readers = "Daily";
}



// WEBPACK FOOTER //
// ./clients/tec-ldh/config.js